import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styles from './badgePrint.module.scss';
import { renderInfoForType } from '../../../utils/helpers';
import Checkbox from '../../../components/checkbox';
import pdficon from '../../../icons/pdf.png';
import CustomPrintDetails from '../../forms/Details/steps/Defaultprint/CustomPrintDetails';

export default function BadgePrint(props) {
    const { printData, translation, user, schemaData, applicationAgreements } = props;
    const profile = useSelector(state => state.auth.profile);
    const gender = printData?.response?.gender;
    const GenderValue = printData?.form?.schema?.fields.filter(field => field.id === 'gender');
    const genderName = GenderValue && GenderValue?.[0]?.values?.filter(fil => fil.key === gender);
    const race = printData?.response?.ethnicity;
    const raceValue = printData?.form?.schema?.fields.filter(field => field.id === 'ethnicity');
    const ethnicity = raceValue && raceValue?.[0]?.values?.filter(fil => fil.key === race);
    const eyeColor = printData?.response?.eye_color;
    const eyeColorValue = printData?.form?.schema?.fields.filter(field => field.id === 'eye_color');
    const eyeColorName = eyeColorValue && eyeColorValue?.[0]?.values?.filter(fil => fil.key === eyeColor);
    const hairColor = printData?.response?.hair_color;
    const hairColorValue = printData?.form?.schema?.fields.filter(field => field.id === 'hair_color');
    const hairColorName = hairColorValue && hairColorValue?.[0]?.values?.filter(fil => fil.key === hairColor);
    const checkboxChecked = schemaData && schemaData.schema?.schema?.fields.filter(fil => printData
    && Object.keys(printData?.response || {}).filter(filt => ['check1', 'check2', 'check3'].includes(filt)).includes(fil.id));
    const multipleRemarks = [];
    if (printData && printData?.additional_info !== null && printData?.additional_info?.[0]?.multipleRemarks) {
      Object.keys(printData?.additional_info?.[0]?.multipleRemarks).forEach((f) => {
        if (
          Object.values(
            printData?.additional_info?.[0]?.multipleRemarks
          ).includes(true)
        ) {
          multipleRemarks.push({ name: f });
        }
      });
    }
    const felonyInvolvingRemarks = [];
    if (printData && printData?.additional_info !== null && printData?.additional_info?.[0]?.felonyInvolvingRemarks) {
      Object.keys(printData?.additional_info?.[0]?.felonyInvolvingRemarks).forEach((f) => {
        if (
          Object.values(
            printData?.additional_info?.[0]?.felonyInvolvingRemarks
          ).includes(true)
        ) {
          felonyInvolvingRemarks.push({ name: f });
        }
      });
    }

    const getPlaceOfBirth = (application) => {
      const pob = application?.answer_schema?.fields.filter(fil => fil.id === 'place_of_birth' && fil.type === 'address');
      if (pob.length > 0) {
        // When the field exists in the schema
        if (application?.response?.place_of_birth?.city && application?.response?.place_of_birth?.city !== '') {
          return `${application?.response?.place_of_birth?.city}, ${application?.response?.place_of_birth?.state}`;
        }
        if (application?.response?.place_of_birth?.state !== '') {
          return application?.response?.place_of_birth?.state;
        }
      } else {
        // When the field does not exist in the schema
        return application?.response?.place_of_birth?.label || '';
      }
      return '';
    };

    const getCompanyName = () => {
      if (printData?.company_name !== null) {
        return printData?.company_name?.name;
      }
      if (typeof printData?.response?.employer === 'object') {
        return printData?.response?.employer?.label;
      }
        return printData?.response?.employer;
    };

    const customFields = printData?.form?.schema?.fields?.filter(field => field.default===false && !field.isDisabled);

    const getStreetValue = (response) => {
      const street = response?.street;
      if (typeof street === 'string') {
        return street;
      }
      if (typeof street === 'object' && street !== null) {
        if ('street' in street) {
          return street.street || '';
        }
        return street.selected_address || street.fulladdress || '';
      }
      return '';
    };
  return (
    <>
        <div className={`${styles.container}`}>
            <div className={styles.stepInfo}>
                <div className={styles.containermain}>
                {profile?.portal_airport?.logo
                ? <>
                    <div className={styles.infoHalfLeft1}>
                    <span><img src={profile?.portal_airport?.logo} style={{ maxWidth: '200px', maxHeight: '200px' }} alt="airport_logo" /></span>
                    </div>
                    <div className={styles.infoHalfRight2}>
                    <div className={styles.infosidehead}>
                        {profile?.portal_airport?.name}
                    </div>
                    </div>
                  </>
                : <div className={styles.infoHalfRight2} style={{ textAlign: 'center', marginLeft: '150px', height: '80px' }}>
                    <div className={styles.infosidehead} style={{ fontSize: '16px', marginBottom: '20px', marginTop: '20px' }}>
                    {profile?.portal_airport?.name}
                    </div>
                    <div className={styles.infosidehead} style={{ fontSize: '16px', marginBottom: '20px' }}>
                    {profile?.portal_airport?.name}
                    </div>
                  </div>
                }
                </div>
            </div>
            <div className={styles.titleContainer}>
              <span className={`${styles.title} mt-4 mb-4`}>
                <FormattedMessage
                id="lease.contacts.personalInfo"
                defaultMessage="Personal Information"
                />
              </span>
            </div>
            <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
              <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                  <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                          id="noise_log.public.name"
                          defaultMessage="First Name"
                      />
                  </span>
                  <p>{printData && printData.first_name}</p>
              </div>
              {printData?.form?.schema?.fields?.map(field => (
              <>
                  {field.id === 'middle_name' && !field?.isDisabled && (
                      <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                      <span className={`${styles.title} mt-4 mb-4`}>
                          <FormattedMessage
                          id={field.id}
                          defaultMessage={field.title}
                          />
                      </span>
                      <p>{printData?.response?.middle_name}</p>
                      </div>
                  )}
              </>
              ))}
              <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                  <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                          id="noise_log.last.name"
                          defaultMessage="Last Name"
                      />
                  </span>
                  <p>{printData && printData.last_name}</p>
              </div>
            </div>
            <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
              <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                  <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id="application.detail.request.phone"
                      defaultMessage="Phone"
                  />
                  </span>
                  <p>{printData && printData.phone_number}</p>
              </div>
              <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                  <span className={`${styles.title} mt-4 mb-4`}>
                  <FormattedMessage
                      id="application.detail.request.email"
                      defaultMessage="Email"
                  />
                  </span>
                  <p>{printData && printData.email}</p>
              </div>
            </div>
            {(printData?.response?.aliases_first) || (printData?.response?.aliases_middle) || (printData?.response?.aliases_last)
              ? <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData?.response?.aliases_first && printData.form?.schema?.fields?.map(sch => sch.id === 'aliases_first' && !sch.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id={sch.id}
                      defaultMessage={sch.title}
                      />
                    </span>
                    <p>{printData?.response?.aliases_first}</p>
                  </div>
                ))}
                {printData?.response?.aliases_middle && printData.form?.schema?.fields?.map(sch => sch.id === 'aliases_middle' && !sch.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id={sch.id}
                      defaultMessage={sch.title}
                      />
                    </span>
                    <p>{printData?.response?.aliases_middle}</p>
                  </div>
                ))}
                {printData?.response?.aliases_last && printData.form?.schema?.fields?.map(sch => sch.id === 'aliases_last' && !sch.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id={sch.id}
                      defaultMessage={sch.title}
                      />
                    </span>
                    <p>{printData?.response?.aliases_last}</p>
                  </div>
                ))}
                </div>
              : ''
              }
              {(printData?.response?.street?.street) || (printData?.response?.street?.city) || (printData?.response?.city)
              ? <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData?.response?.street?.street && printData.form?.schema?.fields?.map(field => field.id === 'street' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{getStreetValue(printData?.response)}</p>
                  </div>
                ))}
                {printData.form?.schema?.fields?.map(field => field.id === 'city' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.street?.city || printData?.response?.city}</p>
                  </div>
                ))}
                </div>
              : ''
              }
              {(printData?.response?.street?.state) || (printData?.response?.street?.zip) || (printData?.response?.street?.country)
                || (printData?.response?.state) || (printData?.response?.zip) || (printData?.response?.country)
              ? <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData.form?.schema?.fields?.map(field => field.id === 'state' && !field.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.street?.state || printData?.response?.state}</p>
                  </div>
                ))}
                {printData.form?.schema?.fields?.map(field => field.id === 'zip' && !field.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.street?.zip || printData?.response?.zip}</p>
                  </div>
                ))}
                {printData.form?.schema?.fields?.map(field => field.id === 'country' && !field.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.street?.country?.label || printData?.response?.country?.label}</p>
                  </div>
                ))}
                </div>
              : ''
              }
              {(printData?.response?.date_of_birth) || (printData?.response?.place_of_birth)
              ? <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData?.response?.date_of_birth && printData.form?.schema?.fields?.map(
                  field => field.id === 'date_of_birth' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.date_of_birth && renderInfoForType({ 'type': 'date' },
                      printData?.response?.date_of_birth, null, null)}
                    </p>
                  </div>
                )
                )}
                {printData?.response?.place_of_birth && printData.form?.schema?.fields?.map(
                  field => field.id === 'place_of_birth' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{getPlaceOfBirth(printData)}</p>
                  </div>
                )
                )}
                </div>
              : ''
              }
              {(printData?.response?.nation_of_citizenship) || ethnicity || genderName
              ? <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData?.response?.nation_of_citizenship && printData.form?.schema?.fields?.map(
                  field => field.id === 'nation_of_citizenship' && !field.isDisabled && (
                    <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.nation_of_citizenship?.label}</p>
                    </div>
                )
                )}
                {ethnicity && printData.form?.schema?.fields?.map(field => field.id === 'ethnicity' && !field.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{ethnicity && ethnicity?.[0]?.value}</p>
                  </div>
                ))}
                {genderName && printData.form?.schema?.fields?.map(field => field.id === 'gender' && !field.isDisabled && (
                  <div className={styles.infoHalf} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{genderName && genderName?.[0]?.value}</p>
                  </div>
                ))}
                </div>
              : ''
              }
              {(printData?.response?.height) || (printData?.response?.weight)
              ? <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData?.response?.height && printData.form?.schema?.fields?.map(field => field.id === 'height' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.height}</p>
                  </div>
                ))}
                {printData?.response?.weight && printData.form?.schema?.fields?.map(field => field.id === 'weight' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                        <FormattedMessage
                        id={field.id}
                        defaultMessage={field.title}
                        />
                    </span>
                    <p>{printData?.response?.weight}</p>
                  </div>
                ))}
                </div>
              : ''
              }
              { eyeColorName || hairColorName
              ? <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {eyeColorName && printData.form?.schema?.fields?.map(field => field.id === 'eye_color' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                      />
                    </span>
                    <p>{eyeColorName && eyeColorName?.[0]?.value}</p>
                  </div>
                ))}
                {hairColorName && printData.form?.schema?.fields?.map(field => field.id === 'hair_color' && !field.isDisabled && (
                  <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                    <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                      />
                    </span>
                    <p>{hairColorName && hairColorName?.[0]?.value}</p>
                  </div>
                ))}
                </div>
              : ''
              }
              {customFields?.length > 0 && (
                <CustomPrintDetails
                  data={printData.response}
                  version={printData?.from?.schema?.version}
                  fields={customFields}
                />
              )}
            {printData && printData.form?.schema?.fields?.find(f => ((f.id === 'employer' && !f.isDisabled)
            || (f.id === 'job_title' && !f.isDisabled))) && (
              <>
                <div className={styles.titleContainer}>
                  <span className={`${styles.title} mt-4 mb-4`}>
                      <FormattedMessage
                      id="lease.contacts.personalInfo1"
                      defaultMessage="Employer Information"
                      />
                  </span>
                </div>
                <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData && printData.form?.schema.fields.map(f => (
                  <>
                  {f.type!=='header' && (f.id === 'employer') && !f?.isDisabled && (
                    <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                        <span>
                          {f.type!=='header' && translation && translation[f.title]
                            ? translation[f.title]
                            : f.title}
                        </span>
                        <p>{getCompanyName()}</p>
                    </div>
                    )}
                    {f.type!=='header' &&(f.id==='job_title'|| f.id==='city_state_zip') && !f?.isDisabled && (
                        <div className={styles.infoHalf1} style={{ borderTop: '1px solid var(--border-default)' }}>
                          <span>
                            {f.type!=='header' && translation && translation[f.title]
                              ? translation[f.title]
                              : f.title}
                          </span>
                          <p>{printData && printData?.response
                          && renderInfoForType(f, printData?.response[f.id], printData, false, undefined, true)}
                          </p>
                        </div>
                    )}
                  </>
                ))}
                </div>
              </>
            )}
            {printData && printData.form?.schema?.fields?.find(field => (field.id === 'social_security_number' && !field.isDisabled)
            || (field.id === 'driver_state'&& !field.isDisabled) || (field.id === 'drivers_license_number'&& !field.isDisabled)) && (
            <>
            <div className={styles.titleContainer}>
                <span className={`${styles.title} mt-4 mb-4`}>
                    <FormattedMessage
                    id="lease.contacts.personalInfo1"
                    defaultMessage="Identification"
                    />
                </span>
            </div>
            <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
            {printData.form?.schema?.fields?.map(field => (
              <>
                {field.id === 'social_security_number' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                </span>
                    <p>XXX-XX-XXXX</p>
                </div>
                )}
                {field.id === 'passport' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                  </span>
                  <p>{printData?.response?.passport}</p>
                </div>
                )}
                {field.id === 'passport_country' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                  </span>
                  <p>{printData?.response?.passport_country?.label}</p>
                </div>
                )}
                {field.id === 'alien_registration_number' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                  </span>
                  <p>{printData?.response?.alien_registration_number}</p>
                </div>
                )}
                {field.id === 'drivers_license_number' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                  </span>
                  <p>{printData?.response?.drivers_license_number}</p>
                </div>
                )}
                {field.id === 'driver_state' && !field?.isDisabled && (
                <div className={styles.infoHalf}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id={field.id}
                      defaultMessage={field.title}
                    />
                  </span>
                  <p>{printData?.response?.driver_state?.value}</p>
                </div>
                )}
              </>
            ))}
            </div>
            </>
            )}
            {printData && printData?.attachments_listA?.length > 0 && (
            <>
            <div className={styles.titleContainer}>
            <span className={`${styles.title} mt-4 mb-4`}>
                <FormattedMessage
                id="lease.contacts.personalInfo1"
                defaultMessage="List A Documents"
                />
            </span>
            </div>
            {printData?.attachments_listA?.[0]?.content_type?.includes('image') && (
            <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                <img src={printData?.attachments_listA?.[0]?.url} alt="documents" style={{ width: '300px', height: '175px', padding: '10px' }} />
            </div>
            )}
            {printData?.attachments_listA?.[0]?.content_type === 'application/pdf' && (
            <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                <img src={pdficon} alt="documents" style={{ width: '300px', height: '175px', padding: '10px' }} />
            </div>
            )}
            </>
            )}
            {printData && printData?.attachments_listB?.length > 0 && (
              <>
                <div className={styles.titleContainer}>
                <span className={`${styles.title} mt-4 mb-4`}>
                    <FormattedMessage
                    id="lease.contacts.personalInfo1"
                    defaultMessage="List B Documents"
                    />
                </span>
                </div>
                {printData?.attachments_listB?.[0]?.content_type?.includes('image') && (
                <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                    <img src={printData?.attachments_listB?.[0]?.url} alt="documents" style={{ width: '300px', height: '175px', padding: '10px' }} />
                </div>
                )}
                {printData?.attachments_listB?.[0]?.content_type === 'application/pdf' && (
                <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                    <img src={pdficon} alt="documents" style={{ width: '300px', height: '175px', padding: '10px' }} />
                </div>
                )}
              </>
            )}
            {printData && printData?.attachments_listC?.length > 0 && (
              <>
                <div className={styles.titleContainer}>
                <span className={`${styles.title} mt-4 mb-4`}>
                    <FormattedMessage
                    id="lease.contacts.personalInfo1"
                    defaultMessage="List C Documents"
                    />
                </span>
                </div>
                {printData?.attachments_listC?.[0]?.content_type?.includes('image') && (
                <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                    <img src={printData?.attachments_listC?.[0]?.url} alt="documents" style={{ width: '300px', height: '175px', padding: '10px' }} />
                </div>
                )}
                {printData?.attachments_listC?.[0]?.content_type === 'application/pdf' && (
                <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                    <img src={pdficon} alt="documents" style={{ width: '300px', height: '175px', padding: '10px' }} />
                </div>
                )}
              </>
            )}
            {printData && printData?.application_checklists?.badge_checklists?.length > 0 && (
            <div className={styles.titleContainer}>
            <span className={`${styles.title} mt-4 mb-4`}>
                <FormattedMessage
                id="application.checklist"
                defaultMessage="Application Checklist"
                />
            </span>
            </div>
            )}
            {printData?.payment && printData?.payment?.txn_id && (
                <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                    <div className={styles.infoHalf}>
                    <span className={styles.title}>
                    <FormattedMessage
                        id="application.checklist11"
                        defaultMessage="Payment Information"
                    />
                    </span>
                    </div>
                    <div className={styles.infoHalf}>
                    <span className={styles.title}>
                    <FormattedMessage
                        id="noice.log.status"
                        defaultMessage="Status"
                    />
                    </span>
                    <p>Verified</p>
                    </div>
                    <div className={styles.infoHalf}>
                    <span className={styles.title}>
                    <FormattedMessage
                        id="noice.log.statuss"
                        defaultMessage="Payment Amount"
                    />
                    </span>
                    <p>{user?.airport_settings?.currency !== null && user?.airport_settings?.currency}{printData?.payment?.amount}</p>
                    </div>
                </div>
            )}
            {printData && printData?.application_checklists?.badge_checklists?.length > 0 && (
               <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                {printData && printData?.application_checklists?.badge_checklists?.map(che => (
                  <>
                    <div className={styles.infoHalf}>
                    <span className={styles.title}>
                        <FormattedMessage
                            id="workorder.parts.pname"
                            defaultMessage="Name"
                        />
                    </span>
                    <p className={styles.title}>
                    {che?.checklist_fields?.title}
                    </p>
                    </div>
                    <div className={styles.infoHalf}>
                        <span className={styles.title}>
                        <FormattedMessage
                            id="noice.log.status"
                            defaultMessage="Status"
                        />
                        </span>
                        <p>Completed</p>
                    </div>
                    <div className={styles.infoHalf}>
                        <span className={styles.title}>
                        <FormattedMessage
                            id="noice.log.statuss"
                            defaultMessage="Completed Date"
                        />
                        </span>
                        <p>{renderInfoForType({ 'type': 'date' }, che?.completed_date, null, null)}</p>
                    </div>
                  </>
                ))
                }
               </div>
            )}
            {printData && printData?.application_filled_by === 'Applicant' && (
            <>
              <div className={styles.titleContainer}>
              <span className={`${styles.title} mt-4 mb-4`}>
                  <FormattedMessage
                  id="application.checklistt"
                  defaultMessage="Acknowledgement"
                  />
              </span>
              </div>
              <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                <div className={styles.acknowldgementdata}>
                  <p style={{ borderBottom: '1px solid var(--border-default)' }}>(a) No person may: </p>
                  <p>(1) Tamper or interfere with, compromise, modify, attempt to
                  circumvent, or cause a person to tamper or interfere with,
                  compromise, modify, or attempt to circumvent any security system,
                  measure, or procedure implemented under this subchapter.
                  </p>
                  <p>(2) Enter, or be present within, a secured area, AOA, SIDA or sterile
                  area without complying with the systems, measures, or procedures
                  being applied to control access to, or presence or movement in, such
                  areas.
                  </p>
                  <p>(3) Use, allow to be used, or cause to be used, any airport-issued or
                  airport-approved access medium or identification medium that
                  authorizes the access, presence, or movement of persons or vehicles
                  in secured areas, AOA&apos;s, or SIDA&apos;s in any other manner than that for
                  which it was issued by the appropriate authority under this
                  subchapter.
                  </p>
                  {checkboxChecked && checkboxChecked.length > 0 && (
                    <div className="mt-4">
                    {checkboxChecked?.map(che => (
                      <div style={{ display: 'flex', marginTop: '10px' }}>
                      <Checkbox
                        checked
                      />
                      <p>{che.title}</p>
                      </div>
                    ))}
                    </div>
                  )}
                  {schemaData && schemaData?.settings && schemaData?.settings?.checkbox_section === true && (
                    <div>
                      <p style={{ borderBottom: '1px solid var(--border-default)', marginTop: '10px' }}>
                        DISQUALIFYING CRIMINAL OFFENSES – SIDA/SECURED/STERILE/AOA ONLY
                      </p>
                      <p>FAR §1542.209 (d) An individual has a disqualifying offense if the individual has been convicted, or found not guilty
                        of or by reason of insanity, of any of the disqualifying crimes listed in this paragraph in any jurisdiction during the 10
                        years before the date of the individual’s application for unescorted access authority, or while the individual has unescorted
                        access authority.
                      </p>
                      <p style={{ marginTop: '10px', fontWeight: 'bold' }}>
                        HAVE YOU BEEN CONVICTED, OR FOUND NOT GUILTY BY REASON OF INSANITY OF ANY OF THE FOLLOWING IN THE PAST 10 YEARS?
                      </p>
                      {multipleRemarks.length > 0 && (
                        <>
                        {multipleRemarks?.map(mul => <p className="mb-1"><li>{mul.name}</li></p>)}
                        </>
                      )}
                      {felonyInvolvingRemarks.length > 0 && (
                        <>
                        {felonyInvolvingRemarks?.map(mul => <p className="mb-1"><li>{mul.name}</li></p>)}
                        </>
                      )}
                      {printData && printData?.additional_info?.[0]?.noneCheckbox === true && (
                        <p>No</p>
                      )}
                      <p className="mt-4">Federal regulations under 49 CFR 1542.209(I) impose a continuing obligation to disclose to the
                        airport operator within 24 hours if he or she is convicted of any disqualifying criminal offense that occurs
                        while he or she has unescorted access authority.
                      </p>
                      <p className="mt-3">By signing this application below I acknowledge that I have not been convicted or found not guilty
                        by reason of insanity of any of the disqualifying criminal offenses listed within the last 10 years, nor have I been
                        arrested for any of the disqualifying offenses and am awaiting judicial proceedings.Additionally, by signing this application
                        below I acknowledge that I will notify {user?.airport?.name} within 24 hours if I am convicted or found not guilty by reason
                        of insanity of any disqualifying criminal offense while I have unescorted access authority.
                      </p>
                      <p className="mt-3">If the background check contains any outstanding warrant(s) for your arrest for any offense(s) ,
                        whether disqualifiable or not, your security badge will be denied until such time as documentation is provided to
                        the ASC that said warrant(s) have been cleared from your record and are no longer active.
                      </p>
                    </div>
                  )}
                  {printData && printData?.additional_info?.[0]?.agreements.length !== 0 && (
                    <div>
                      <p style={{ borderBottom: '1px solid var(--border-default)', marginTop: '10px' }}>AGREEMENTS</p>
                      <div className="mt-2">
                        {applicationAgreements?.map(eachAgreement => (
                          <>
                            <p style={{ marginBottom: '0px' }}><b>{eachAgreement?.agreement_title}&nbsp;</b>
                            – {eachAgreement?.agreement_description}
                            </p>
                            <span style={{ color: '#8C9EA7' }}>Initial</span>
                            <div style={{ marginBottom: '20px' }}>
                            <input
                                name={eachAgreement?.agreement_title}
                                id={eachAgreement?.agreement_title}
                                disabled
                                type="text"
                                value={printData?.additional_info?.[0]?.agreements?.[eachAgreement?.agreement_title]}
                            />
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
            )}
            {printData?.badge_expiry_date && (
          <>
            <div className={styles.titleContainer}>
              <span className={`${styles.title} mt-4 mb-4`}>
                  <FormattedMessage
                  id="application.checklistt"
                  defaultMessage="Badge Expiry date"
                  />
              </span>
            </div>
            <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
              <span className={`${styles.title} mt-4 mb-4 ml-4`}>
                  {renderInfoForType({ 'type': 'date' }, printData?.badge_expiry_date, null, null)}
              </span>
            </div>
          </>
            )}
        </div>
    </>
  );
}
